import React, { useEffect, useMemo, useState } from "react";
import { Box, IconButton, Modal, TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import {
  fetchGetAllUser,
  fetchClientNameData,
  fetchOrgClientWiseData,
  addUserData,
  updateUserData,
  deleteUserData,
  overAllUsersSearch
} from "../../../../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import Topbar from "../../../../scenes/global/Topbar";

const GyanniUsers = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [loading, setLoading] = useState(false);
  const [allUser, setAllUser] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentClient, setCurrentClient] = useState(null);

  const [selectedClient, setSelectedClient] = useState("");
  const [selectedOrgVal, setSelectedOrgVal] = useState("");
  const [organizationData, setOrganizationData] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedParentVal, setSelectedParentVal] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loginName, setLoginName] = useState("");
  const [password, setPassword] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobileNumber, setUserMobileNumber] = useState("");
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  const clientid = localStorage.getItem("clientId");
  const mstorgnhierarchytypeid = localStorage.getItem("organizationid");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // First API call to get the total number of records
        if (!clientid || !mstorgnhierarchytypeid) {
          throw new Error("Missing clientid or mstorgnhierarchytypeid");
        }

        // Prepare the data for the first request
        const totalRecordsParams = {
          clientid: Number(clientid),
          mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
          limit: 100, // You can modify this limit if necessary
          offset: offset,
        };

        // First request to get the total count of records
        const initialData = await fetchGetAllUser(totalRecordsParams);
        const total = initialData?.details?.total;

        if (total === 0) {
          setAllUser([]); // If no records found, set empty array
          return;
        }

        setTotalRecords(total);

        // Prepare the data for the second request with the limit set to the total number of records
        const secondRequestParams = {
          clientid: Number(clientid),
          mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
          limit: total, // Using the total value from the first API response
          offset: offset,
        };

        // Second API call to fetch the data based on the total limit
        const secondData = await fetchGetAllUser(secondRequestParams);

        if (secondData && secondData.details && secondData.details.values) {
          const formattedData = secondData.details.values.map((user) => ({
            id: user.id,
            branch: user.branch,
            clientname: user.clientname,
            firstname: user.firstname,
            lastname: user.lastname,
            loginname: user.loginname,
            password: user.password,
            mfaname: user.mfaname,
            name: user.name,
            orgname: user.orgname,
            useremail: user.useremail,
            usermobileno: user.usermobileno,
            usertype: user.usertype,
            vipuser: user.vipuser,
          }));
          setAllUser(formattedData);
        } else {
          throw new Error("Invalid data structure from second API call");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Failed to fetch user data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     setDebouncedSearch(searchText);
  //     setPage(0); 
  //   }, 500); 
  
  //   return () => clearTimeout(delayDebounce);
  // }, [searchText]);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (!clientid || !mstorgnhierarchytypeid) {
          console.warn("Missing clientid or mstorgnhierarchytypeid");
          setAllUser([]);
          setTotalRecords(0);
          return;
        }

        const offset = page * pageSize;

        const params = {
          clientid: Number(clientid),
          mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
          limit: pageSize,
          offset: offset,
          search: debouncedSearch.trim(),
          // search: searchText?.trim() || "",      
          // role: selectedRole || "", 
        };
        const response = await fetchGetAllUser(params);
        if (response?.details?.values && Array.isArray(response.details.values)) {
          const users = response.details.values.map((user) => ({
            id: user.id,
            name: user.name,
            loginname: user.loginname,
            clientname: user.clientname,
            orgname: user.orgname,
            useremail: user.useremail,
            usermobileno: user.usermobileno,
            firstname: user.firstname,
            password: user.password,
            lastname: user.lastname,
          }));
          setAllUser(users);
          setTotalRecords(response.details.total || 0);
          console.log("Users fetched:", users.length);
          console.log("Total records:", response.details.total || 0);
        } else {
          console.warn("No user data found in response.");
          setAllUser([]);
          setTotalRecords(0);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setAllUser([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [clientid, mstorgnhierarchytypeid, page, pageSize]);


  
  const handleClientSelect = (e) => {
    const clientId = e.target.value;
    setSelectedClient(clientId);
    if (clientId) fetchClientNames(clientId);
  };

  const fetchClientNames = async () => {
    const loadingToastId = toast.loading("Loading client data...");

    try {
      const response = await fetchClientNameData({});
      console.log("Response from fetchClientNameData:", response);

      toast.dismiss(loadingToastId);

      if (response.success) {
        setClients(response.details || []);
        toast.success("Client data loaded successfully!", { autoClose: 2000 });
      } else {
        toast.error("Invalid response structure", { autoClose: 2000 });
      }
    } catch (err) {
      console.error("Error fetching client name data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching client name data.", { autoClose: 2000 });
    }
  };

  const handleOrgClientWise = async () => {
    const loadingToastId = toast.loading("Fetching organization data...");

    try {
      if (!selectedClient) {
        toast.dismiss(loadingToastId);
        toast.error("Please select a client first.", { autoClose: 2000 });
        return;
      }

      const clientId =
        typeof selectedClient === "string"
          ? parseInt(selectedClient, 10)
          : selectedClient;

      const response = await fetchOrgClientWiseData({ clientId });

      toast.dismiss(loadingToastId);

      if (response.success) {
        setOrganizationData(response.details || []);
        toast.success("Organization data loaded successfully!", {
          autoClose: 2000,
        });
      } else {
        toast.error("Error: Invalid response structure", { autoClose: 2000 });
      }
    } catch (err) {
      console.error("Error fetching organization data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching organization data.", { autoClose: 2000 });
    }
  };

  const handleFilterChange = async (newFilterModel) => {
    console.log("handleFilterChange", newFilterModel);
    setFilterModel(newFilterModel);
    setLoading(true);
  
    try {
      if (!clientid || !mstorgnhierarchytypeid) {
        throw new Error("Missing clientid or mstorgnhierarchytypeid");
      }
  
      const filterValue = newFilterModel?.items?.[0]?.value || "";
  
      const totalParams = {
        search_string: filterValue,
      };
  
      console.log("totalParams==", totalParams);
  
      const initialData = await overAllUsersSearch(totalParams);
      const values = initialData?.details?.values || [];
  
      const formattedData = values.map((user) => ({
        id: user.id, // This is required for DataGrid
        branch: user.branch,
        clientname: user.clientname,
        firstname: user.firstname,
        lastname: user.lastname,
        loginname: user.loginname,
        password: user.password,
        mfaname: user.mfaname,
        name: user.name,
        orgname: user.orgname,
        useremail: user.useremail,
        usermobileno: user.usermobileno,
        usertype: user.usertype,
        vipuser: user.vipuser,
      }));
  
      setAllUser(formattedData);
      setTotalRecords(formattedData.length); // This must be a number
    } catch (err) {
      console.error("Error fetching filtered user data:", err);
      setAllUser([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  
  

  const openModal = () => {
    setIsModalOpen(true);
    fetchClientNames();
  };

  const handleInsertData = async (e) => {
    const requestedData = {
      clientid: Number(selectedClient),
      mstorgnhirarchyid: Number(selectedParentVal),
      firstname: firstName,
      lastname: lastName,
      loginname: loginName,
      password: password,
      useremail: userEmail,
      usermobileno: userMobileNumber,
    };

    console.log("requestedData === >>", requestedData);

    try {
      const response = await addUserData(requestedData);

      if (response.success) {
        toast.success("User Added Successfully!");
        setIsEditModalOpen(false);

        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
      } else {
        toast.error(response?.message || "Failed to add user!");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentClient((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setIsEditModalOpen(false);
  };

  const handleEdit = (id) => {
    setCurrentClient(id);
    setIsEditModalOpen(true);
  };

  const handleUpdateUserData = async (e) => {
    e.preventDefault(); 

    const loadingToastId = toast.loading("Loading User Data...", {
      toastId: "loadingClients",
      containerId: "clientContainer",
    });

    const requestData = {
      id: currentClient?.id || "",
      firstname: currentClient?.firstname || "",
      lastname: currentClient?.lastname || "",
      loginname: currentClient?.loginname || "",
      useremail: currentClient?.useremail || "",
      usermobileno: currentClient?.usermobileno || "",
    };

    try {
      const updatedClient = await updateUserData(requestData);
      toast.dismiss(loadingToastId);

      if (updatedClient.success) {
        setClients((prevClients) =>
          prevClients.map((client) =>
            client.id === currentClient.id
              ? { ...updatedClient.response }
              : client
          )
        );
        toast.success("Client updated successfully.", {
          containerId: "clientContainer",
          autoClose: 2000,
        });
        closeModal();
      } else {
        toast.error(updatedClient.message || "Failed to update client.", {
          containerId: "clientContainer",
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.dismiss(loadingToastId);
      toast.error("An error occurred while updating user data.", {
        autoClose: 2000,
        containerId: "clientContainer",
      });
    }
  };

  const handleDelete = async (row) => {
    if (!row?.id) return;

    if (
      window.confirm(`Are you sure you want to delete "${row.modulename}"?`)
    ) {
      try {
        const result = await deleteUserData(row.id);
        window.location.reload();
      } catch (error) {
        console.error("Failed to delete module:", error);
      }
    }
  };

  const columns = [
    {
      field: "clientname",
      headerName: "Client Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "orgname",
      headerName: "Organization Name",
      flex: 1,
    },
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
    },
    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
    },
    {
      field: "loginname",
      headerName: "Login Name",
      flex: 1,
    },
    {
      field: "password",
      headerName: "Password",
      flex: 1,
    },
    {
      field: "useremail",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "usermobileno",
      headerName: "Mobile Number",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      renderCell: ({ params }) => (
        <div style={{ display: "flex" }}>
          <IconButton
            onClick={() => handleEdit(params.id)}
            style={{ color: "#6870fa", fontSize: "12px" }}
          >
            <BorderColorIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(params.row)}
            style={{ color: "red", fontSize: "12px" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>

      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <div className="p-4 flex items-center justify-between">
          <h6 className="text-center font-semibold mb-4">User's Details</h6>
          <div
            style={{ backgroundColor: colors.blueAccent[500] }}
            className="text-white px-4 py-2 rounded-sm"
          >
            <button onClick={openModal} className="font-medium">
              {" "}
              <AddIcon /> Add
            </button>
          </div>
        </div>

        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          {/* <DataGrid
            checkboxSelection
            rows={allUser}
            columns={columns}
            pageSize={pageSize}
            page={page}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
            loading={loading}
            filterModel={filterModel}
            onFilterModelChange={handleFilterChange}
          /> */}
{/* 
<div style={{ minWidth: '300px', maxWidth: '500px', width: '100%' }}>
  <TextField
    label="Search users"
    variant="outlined"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    margin="normal"
    fullWidth
  />
</div> */}

<DataGrid
  rows={allUser}
  columns={columns}
  pageSize={pageSize}
  page={page}
  paginationMode="server"
  rowCount={totalRecords}
  onPageChange={(newPage) => setPage(newPage)}
  onPageSizeChange={(newSize) => {
    setPageSize(newSize);
    setPage(0);
  }}
  loading={loading}
  filterModel={filterModel}
  onFilterModelChange={handleFilterChange}
  rowsPerPageOptions={[5, 10, 20, 50]}
  pagination
/>



        </Box>

        {/* // add USER modal pop up  */}
        <div
          className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
            isModalOpen ? "block" : "hidden"
          }`}
        >
          <div className="flex justify-center items-center min-h-screen">
            <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
              <h2 className="text-2xl text-center font-semibold mb-4">
                Add User
              </h2>

              <form onSubmit={handleInsertData}>
                {/* Client Name */}

                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="mb-3">
                    <label
                      htmlFor="clientName"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select Client
                    </label>
                    <div className="w-full max-w-sm min-w-[200px]">
                      <div className="relative">
                        <select
                          className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                          value={selectedClient}
                          onChange={(e) => setSelectedClient(e.target.value)}
                          onClick={handleClientSelect}
                        >
                          <option value="">Select Client</option>
                          {clients.map((client, index) => (
                            <option key={index} value={client.id}>
                              {client.name}
                            </option>
                          ))}
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.2"
                          stroke="currentColor"
                          className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/*  Select Parent Organization */}
                  <div className="mb-3">
                    <label
                      htmlFor="description"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select Parent Organization
                    </label>
                    <div className="w-full max-w-sm min-w-[200px]">
                      <div className="relative">
                        <select
                          value={selectedParentVal}
                          className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                          onClick={handleOrgClientWise}
                          onChange={(e) => setSelectedParentVal(e.target.value)}
                        >
                          <option value="">Select Parent Organization</option>
                          {organizationData.map((org, index) => (
                            <option key={index} value={org.id}>
                              {org.organizationname}
                            </option>
                          ))}
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.2"
                          stroke="currentColor"
                          className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="firstName"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="lastName"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Login Name
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="loginName"
                      value={loginName}
                      onChange={(e) => setLoginName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      User Email
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="userEmail"
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      User Mobile Number
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="userMobileNumber"
                      value={userMobileNumber}
                      onChange={(e) => setUserMobileNumber(e.target.value)}
                    />
                  </div>
                  <div className="col-span-2 flex justify-between space-x-4">
                    <button
                      type="submit"
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                    <button
                      onClick={closeModal}
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                    >
                      X
                    </button>
                  </div>
                </div>
              </form>

              {/* Close button */}
            </div>
          </div>
        </div>

        {/* Modal for editing client */}
        <div
          className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
            isEditModalOpen ? "block" : "hidden"
          }`}
        >
          <div className="flex justify-center items-center min-h-screen">
            <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
              <h2 className="text-2xl text-center font-semibold mb-4">
                Edit User's
              </h2>

              <form onSubmit={handleUpdateUserData}>
                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="mb-3">
                    <TextField
                      label="First Name"
                      name="firstname"
                      value={currentClient?.firstname}
                      onChange={handleChange}
                      fullWidth
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      label="Last Name"
                      name="lastname"
                      value={currentClient?.lastname}
                      onChange={handleChange}
                      fullWidth
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      label=" User Email"
                      name="useremail"
                      value={currentClient?.useremail}
                      onChange={handleChange}
                      fullWidth
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      label="User Mobile Number"
                      name="usermobileno"
                      value={currentClient?.usermobileno}
                      onChange={handleChange}
                      fullWidth
                    />
                  </div>

                  <div className="col-span-2 flex justify-between space-x-4">
                    <button
                      type="submit"
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                    <button
                      onClick={closeModal}
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                    >
                      X
                    </button>
                  </div>
                </div>
              </form>

              {/* Close button */}
            </div>
          </div>
        </div>
        <ToastContainer />
      </Box>
    </>
  );
};

export default GyanniUsers;
